import { Component, OnInit } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { BooknumberService } from '../../services/booknumber-service';
import { UtilityService } from '../../services/utility-service';
import { BookNoSearch, BookNumberReceiptResponse, PavtiReceiptDetails } from '../../models/bookno-receipt-model';
import { TallyReceiptService } from '../../services/tallyentry-service';
import { Finyearmst, TallyReceiptModel, Txncategory } from '../../models/tallyentry-api-model';

@Component({
  selector: 'app-book-number',
  templateUrl: './book-number.component.html',
  styleUrls: ['./book-number.component.css']
})

export class BookNumberComponent implements OnInit {
  public l_receiptsDetails: PavtiReceiptDetails[] = [];
  public l_categoryList: Txncategory[] = [];
  public l_financialYearList = [];
  public l_bookNoformData: BookNoSearch = new BookNoSearch();
  public l_entriesDone = 0;
  public l_entriesRemaining = 0;

  constructor(
    private l_BooknumberService: BooknumberService,
    private l_UtilityService: UtilityService,
    private l_TallyReceiptService: TallyReceiptService,
    public l_utilityService: UtilityService
  ) { }

  ngOnInit(): void {
    this.lFN_GetCategorySelect();
    this.lFN_GetFinancialYear();
  }

  ngAfterViewInit() { }

  // lFN_GetRceiptDetailsForBookNo() {
  //   let l_response =  this.l_BooknumberService.lFN_GetRceiptsDtlBookNumber();
  //   l_response.subscribe({
  //    next: async (data) => {
  //      if (data.status == 200) {
  //        console.log('success_response: ', data);
  //        this.l_UtilityService.lFN_HideLoader();
  //      }
  //    },
  //    error: (l_error) => {
  //      console.error('error_response: ', l_error);
  //      this.l_UtilityService.lFN_ErrorToaster('Unable to fetch receipts list.', 'Failure');
  //      this.l_UtilityService.lFN_HideLoader();
  //    },
  //    complete: () => {
  //      console.log('Request completed');
  //      this.l_UtilityService.lFN_HideLoader();
  //    }
  //  });
  // }

  lFN_GetCategorySelect() {
    let l_response = this.l_TallyReceiptService.lFN_GetCategory();
    l_response.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          let l_categoryResponseList: Txncategory[] = [];
          console.log('success_response: ', JSON.parse(data.body));
          for await (const l_category of JSON.parse(data.body)) {
            l_categoryResponseList.push(new Txncategory(l_category));
          }
          this.l_categoryList = l_categoryResponseList;
          this.l_UtilityService.lFN_HideLoader();
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_UtilityService.lFN_ErrorToaster('Unable to fetch category list.', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  lFN_GetFinancialYear() {
    let l_finyearResponse = this.l_TallyReceiptService.lFN_GetFinyearmst();
    l_finyearResponse.subscribe({
        next: async (data) => {
          if (data.status == 200) {
            let l_financialYearList: Finyearmst[] = [];
            for await (const l_finyear of JSON.parse(data.body)) {
              l_financialYearList.push(new Finyearmst(l_finyear))
            }
            this.l_financialYearList = l_financialYearList;
            console.log(this.l_financialYearList);
            this.l_UtilityService.lFN_HideLoader();
            this.l_bookNoformData.finyearmstId = this.l_financialYearList.find(year => year.status === true)?.finyearmstId;
          }
        },
        error: (l_error) => {
          this.l_UtilityService.lFN_ErrorToaster('Unable to fetch Financial Year', 'Failure');
          this.l_UtilityService.lFN_HideLoader();
        },
        complete: () => {
          this.l_UtilityService.lFN_HideLoader();
        }
      });
  }

 lFN_SearchBookReceipts() {
    this.l_UtilityService.lFN_ShowLoader();
    console.log(this.l_bookNoformData);
    if (!this.l_bookNoformData.finyearmstId || !this.l_bookNoformData.bookNo || !this.l_bookNoformData.txncategoryId) {
      this.l_UtilityService.lFN_WarningToaster('Please fill all the required fields', 'Warning');
      this.l_UtilityService.lFN_HideLoader();
      return;
    }
    let l_response = this.l_BooknumberService.lFN_GetRceiptsDtlBookNumber(this.l_bookNoformData);
    l_response.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          let l_bookReceiptsResponse = new BookNumberReceiptResponse(JSON.parse(data.body));
          let l_pavDetailsList = l_bookReceiptsResponse.pavtiReceiptDetailsList;
          this.l_receiptsDetails = l_pavDetailsList;
    
          let l_entriescompleted = 0
          let l_entriesRemainingReset = 0;
    
          for await (const l_receiptsInfo of this.l_receiptsDetails) {
            if (l_receiptsInfo.status == true) {
              l_entriescompleted++;
            } else if (l_receiptsInfo.status == false) {
              l_entriesRemainingReset++;
            }
          }
          this.l_entriesDone =  l_entriescompleted;
          this.l_entriesRemaining =  l_entriesRemainingReset;
          this.l_UtilityService.lFN_HideLoader();
        }
      },
      error: (l_error) => {
        this.l_UtilityService.lFN_ErrorToaster('Unable to fetch Book Receipt Details', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  lFN_GetFinancialYearText(finyearmstId: number) {
    if (finyearmstId) {
      const year = this.l_financialYearList.find(year => year.finyearmstId === finyearmstId);
      return year ? year.finyear : '';
    }

  }
  
}
